import { render, staticRenderFns } from "./productionCode.vue?vue&type=template&id=9ca20c1c&scoped=true&"
import script from "./productionCode.vue?vue&type=script&lang=js&"
export * from "./productionCode.vue?vue&type=script&lang=js&"
import style0 from "./productionCode.vue?vue&type=style&index=0&id=9ca20c1c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca20c1c",
  null
  
)

export default component.exports